export default __webpack_public_path__ + "static/amex-a2fb1697be8491b7adf66afeb1028074.jpg";